/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { AppWrap } from '../../wrapper';
import { roles as rolesData } from '../../data/portfolio';
import './Header.scss';

// Import icons from react-icons
import {
  SiReact,
  SiAmazonaws,
  SiOpenai
} from 'react-icons/si';
import { MdPhoneIphone } from 'react-icons/md';
import { FaServer } from 'react-icons/fa';

// Icon mapping
const iconMap = {
  SiReact,
  SiAmazonaws,
  SiOpenai,
  MdPhoneIphone,
  FaServer
};

const Header = () => {
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    setRoles(rolesData);
  }, []);

  return (
    <div className="app__header app__flex">
      <div className="app__header-content">
        <div className="app__header-badge">
          <h1 className="head-text">Varan Bhalla</h1>
          <p className="p-text">Full Stack Software Engineer</p>

          <a href="#contact" className="app__header-cta">
            Let&apos;s Connect →
          </a>
        </div>

        <div className="app__header-roles">
          {roles.map((role, index) => {
            const IconComponent = iconMap[role.icon];
            return (
              <motion.div
                whileInView={{ opacity: 1 }}
                whileHover={{ scale: 1.1 }}
                transition={{ duration: 0.5, type: 'tween' }}
                className="app__header-role-item"
                key={role.title + index}
              >
                <div className="app__header-role-icon">
                  {IconComponent && <IconComponent size={40} />}
                </div>
                <p className="bold-text">{role.title}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AppWrap(Header, 'home');
